<div class="row" [ngClass]="isLargeView ? 'row-cols-2' : 'row-cols-1'">
  <div class="col">
    @if (currentStep == 1) {
      @if (fileUploadError) {
        <div class="alert alert-danger my-3">
          {{ fileUploadError }}
        </div>
      }
      <div class="col my-3">
        <button
          type="button"
          class="btn btn-md w-100"
          [ngClass]="uploadFile ? 'btn-outline-primary' : 'btn-primary'"
          (click)="selectFile()"
        >
          {{ uploadFile ? "Change File" : "Upload File" }}
        </button>

        <input
          #fileInput
          id="fileInput"
          style="display: none; cursor: pointer"
          type="file"
          accept=".pdf"
          (change)="handleFileInput($event)"
        />
      </div>
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-dark w-100 btn-lg">Cancel</button>

        <button
          type="submit"
          class="btn btn-primary w-100 btn-lg"
          (click)="currentStep = 2; assigneeList = []; getAssignees()"
          [disabled]="!uploadFile"
        >
          Next
        </button>
      </div>
    }
    @if (currentStep == 2) {
      @if (assigneeList.length > 1) {
        <div class="mb-1">
          <gtapp-auto-complete
            [data]="assigneeSearchList"
            placeHolder="Search Guard"
            searchKeyword="full_name"
            [itemTemplate]="assigneeTemplate"
            (inputChanged)="searchAssignee($event)"
            (selected)="selectDeselectSingleAssignee($event)"
            [enableCloseOption]="true"
          >
          </gtapp-auto-complete>
        </div>

        <ng-template #assigneeTemplate let-guard>
          <div>
            {{ guard?.full_name || guard?.email }}
          </div>
        </ng-template>
      }
      <div class="overflow-assignee mb-3" id="assigneeList">
        <table class="table my-2">
          <tbody>
            @for (assignee of assigneeList; track $index) {
              <tr
                class="cursor-pointer"
                (click)="selectDeselectSingleAssignee(assignee)"
              >
                <td>
                  <div class="d-flex">
                    <div>
                      <div class="form-floating">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [checked]="
                            selectedAssigneeIds?.includes(assignee?.id)
                          "
                        />
                      </div>
                    </div>
                    <div class="flex-grow-1 ms-2">
                      {{ assignee?.full_name }}
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      @if (
        sopAssigneeTotalPages > 1 &&
        sopAssigneeTotalCount != assigneeList?.length
      ) {
        <button
          type="button"
          class="btn btn-secondary btn-lg"
          (click)="onLoadMoreAssignees()"
        >
          Load More
        </button>
      }
      <div class="d-flex gap-2 my-3">
        <button
          type="button"
          class="btn btn-dark w-100 btn-lg"
          (click)="currentStep = 1"
        >
          Back
        </button>

        <button
          type="submit"
          class="btn btn-primary w-100 btn-lg"
          [disabled]="!selectedAssigneeIds?.length"
          (click)="addSOPPressed = true; onAddSOP()"
        >
          Send
        </button>
      </div>
    }
  </div>
  @if (pdfFileUrl) {
    <div class="col p-3 border">
      <iframe
        [src]="pdfFileUrl"
        frameborder="0"
        allowfullscreen="true"
        allow="fullscreen"
      ></iframe>
    </div>
  }
</div>
